import { combineReducers } from 'redux';
import appReducer from "./app.js";
import contactsReducer from "./contacts.js";
import contactListsReducer from "./contactLists.js";
import usersReducer from "./users.js";
export default combineReducers({
  app: appReducer,
  contacts: contactsReducer,
  contactLists: contactListsReducer,
  users: usersReducer
});